import { useMutation, useQueryClient } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import { Database } from '@/_constants/database.types';

type AttemptAnswer = Database['public']['Tables']['past_paper_attempt_answers']['Row'];

interface UpdateAnswerParams {
  attemptId: string;
  questionId: string;
  answerText: string;
}

const useUpdateAnswer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ attemptId, questionId, answerText }: UpdateAnswerParams): Promise<AttemptAnswer> => {
      // Upsert the answer (insert if doesn't exist, update if it does)
      const { data, error } = await supabaseClient
        .from('past_paper_attempt_answers')
        .upsert(
          {
            attempt_id: attemptId,
            question_id: questionId,
            answer_text: answerText,
          },
          {
            onConflict: 'attempt_id,question_id',
          }
        )
        .select()
        .single();

      if (error) throw error;

      return data;
    },
    onSuccess: (data) => {
      // Invalidate the attempt query to refetch with updated answers
      queryClient.invalidateQueries({ queryKey: ['paper_attempt', data.attempt_id] });
    },
  });
};

export default useUpdateAnswer;
